module.exports = __webpack_public_path__ + "assets/img/E-a114d896.jpg";